module.exports = __webpack_public_path__ + "assets/img/news1.2.04f1330f.png";